import {
  SupportCenterFolders,
  SupportCenterFile,
} from '@intellio/shared/models';
import { createAction, props } from '@ngrx/store';

export enum SupportCenterActionTypes {
  GetFolders = '[Folders] Get',
  GetFoldersSuccess = '[Folders] Get Succeeded',
  GetFoldersFailure = '[Folders] Get Failure',
  GetFiles = '[Files] Get',
  GetFilesSuccess = '[Files] Get Succeeded',
  GetFilesFailure = '[Files] Get Failure',
  GetFilesList = '[Files List] Get',
  GetFilesListSuccess = '[Files List] Get Succeeded',
  GetFilesListFailure = '[Files List] Get Failure',
}

export const getFolders = createAction(SupportCenterActionTypes.GetFolders);

export const getFoldersSuccess = createAction(
  SupportCenterActionTypes.GetFoldersSuccess,
  props<{ folders: SupportCenterFolders }>()
);

export const getFoldersFailure = createAction(
  SupportCenterActionTypes.GetFoldersFailure,
  props<{ error: any }>()
);

export const getFiles = createAction(
  SupportCenterActionTypes.GetFiles,
  props<{ path: string }>()
);

export const getFilesSuccess = createAction(
  SupportCenterActionTypes.GetFilesSuccess,
  props<{ path: string; files: SupportCenterFile }>()
);

export const getFilesFailure = createAction(
  SupportCenterActionTypes.GetFilesFailure,
  props<{ error: any }>()
);

export const getFilesList = createAction(
  SupportCenterActionTypes.GetFilesList,
  props<{ path: string }>()
);

export const getFilesListSuccess = createAction(
  SupportCenterActionTypes.GetFilesListSuccess,
  props<{ path: string; filesList: SupportCenterFolders[] }>()
);

export const getFilesListFailure = createAction(
  SupportCenterActionTypes.GetFilesListFailure,
  props<{ error: any }>()
);
